import React, { FC } from 'react';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { getResponsiveStyle } from '@utils/responsive';

type SpaceBreakpoints = {
    space: 15 | 30 | 50 | 100;
};

export interface SpaceProps {
    orientation?: 'vertical' | 'horizontal';
    // styles apply from breakpoint up
    spaceBreakpoints: {
        xs?: SpaceBreakpoints;
        sm?: SpaceBreakpoints;
        md?: SpaceBreakpoints;
        lg?: SpaceBreakpoints;
        xl?: SpaceBreakpoints;
        xxl?: SpaceBreakpoints;
    };
}

export const Space: FC<SpaceProps> = ({ orientation, spaceBreakpoints }) => {
    const pageSize = useMediaQuery();

    const space = getResponsiveStyle('space', pageSize, spaceBreakpoints);

    return <div style={orientation === 'horizontal' ? { width: `${space}px` } : { height: `${space}px` }} />;
};
